/** Сообщение после оплаты с пересчётом посещений */
export function activationSuccessMessage(activation) {
  if (activation?.debt_payment) {
    if (activation.fully_paid || !(activation.amount_due > 0)) {
      return "Оплата принята, долг закрыт";
    }
    const left = Math.round(Number(activation.amount_due) || 0);
    return `Оплата принята. Осталось к оплате: ${left.toLocaleString("ru-RU")} ₽`;
  }
  if (activation?.pending_payment) {
    const left = Math.round(
      Number(activation.amount_due ?? activation.required - activation.paid_total) ||
        0,
    );
    return `Частичная оплата записана. Осталось: ${left.toLocaleString("ru-RU")} ₽`;
  }
  if (activation?.complimentary && !activation?.charged) {
    return "Абонемент активирован без оплаты";
  }
  if (!activation || !activation.charged) {
    return "Оплата принята, абонемент активирован";
  }
  const n = activation.charged;
  const rest = activation.visits_remaining;
  const word =
    n % 10 === 1 && n % 100 !== 11
      ? "занятие"
      : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20)
        ? "занятия"
        : "занятий";
  return `Абонемент активирован. Списано ${n} ${word} за предыдущие тренировки. Остаток: ${rest ?? "—"}.`;
}

export function activationWarningMessage(activation) {
  const conflicts = activation?.conflicts?.length ?? 0;
  const skipped = activation?.skipped ?? 0;
  if (!conflicts && !skipped) return null;
  if (conflicts > 0) {
    return `${conflicts} посещ. уже списаны по другому абонементу — пропущены`;
  }
  return null;
}
